export default "__VITE_ASSET__DnSXPQwp__"